














import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';

@Component({})
export default class TableSearchBar extends Vue {
	public searchTerm = '';

	@Prop(Array)
	public itemList!: [];

	public searchItems(arr: any, searchTerm: string) {
		if (arr) {
			this.$emit(
				'filtered',
				arr.filter(obj => obj.name.toLowerCase().includes(searchTerm.toLowerCase())),
			);
		}
	}
}
